import { MultiselectCommand } from '../../core/model/command';

export class TransferMultiselectCommand extends MultiselectCommand {
  constructor(id: string, items: any[], itemsSource: any[], contextId?: string) {
    super(id, items, itemsSource, contextId);
  }
}
